'use client';

import { getTranslationHook } from '@coolblue-development/next-translations/client';

import config from './config';

export const useTranslation = getTranslationHook(config);
